// extracted by mini-css-extract-plugin
export var actionText = "_gv-4";
export var container = "_gv-0";
export var leftSection = "_gv-1";
export var rightSection = "_gv-2";
export var settingsButton = "_gv-6";
export var settingsIcon = "_gv-7";
export var shortcut = "_gv-5";
export var shortcutGroup = "_gv-3";